export default __webpack_public_path__ + "static/media/library.13170c1d.svg";